import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RegistrationProgressBarComponent } from './registration-progress-bar/registration-progress-bar.component';
import { EmailFieldComponent } from './email-field/email-field.component';
import { CustomSelectFieldComponent } from './custom-select-field/custom-select-field.component';
import { SelectFieldComponent } from './select-field/select-field.component';
import { PhoneFieldComponent } from './phone-field/phone-field.component';
import { TextFieldComponent } from './text-field/text-field.component';
import { MultilineTextFieldComponent } from './multiline-text-field/multiline-text-field.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DateFieldComponent } from './date-field/date-field.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { RadioFieldComponent } from './radio-field/radio-filed.component';
import { PasswordFieldComponent } from './password-field/password-field.component';
import { CustomValidators } from './validators/custom-validators';
import { SmsCodeFieldComponent } from './sms-code-field/sms-code-field.component';
import { SharedModule } from '../shared/shared.module';
import { SearchInputComponent } from './search-input/search-input.component';
import { QuizNPSComponent } from './quizNPS/quizNPS.component';
import { QuizMobileComponent } from './quizMobile/quizMobile.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { StepsModule } from 'primeng/steps';
import { AutocompleteFioComponent } from './autocomplete-fio/autocomplete-fio.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Dadata2Service } from '../../services/dadata2.service';
import { AutocompleteAddressComponent } from './autocomplete-address/autocomplete-address.component';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { GenderBoxComponent } from './gender-box/gender-box.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NumberFieldComponent } from './number-field/number-field.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { OtpFieldComponent } from './otp-field/otp-field.component';
import { SpinnerModule } from 'primeng/spinner';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import {DateInputComponent} from "./date-input/date-input.component";
import {AmountSliderFieldComponent} from "./amount-slider-field/amount-slider-field.component";
import {AmountSliderComponent} from "./amount-slider/amount-slider.component";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {maskConfig} from "../../constants/mask-config";
import {ProgressBarModule} from "primeng/progressbar";
import {AutocompleteEmailComponent} from "./autocomplete-email/autocomplete-email.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        InputTextModule,
        InputMaskModule,
        CalendarModule,
        DropdownModule,
        StepsModule,
        AutoCompleteModule,
        PasswordModule,
        CheckboxModule,
        InputTextareaModule,
        DividerModule,
        DialogModule,
        RadioButtonModule,
        RatingModule,
        SelectButtonModule,
        InputNumberModule,
        SpinnerModule,
        ProgressSpinnerModule,
        NgxMaskDirective,
        OverlayPanelModule,
        NgxSliderModule,
        ProgressBarModule,
    ],
    declarations: [
        RegistrationProgressBarComponent,
        SmsCodeFieldComponent,
        TextFieldComponent,
        MultilineTextFieldComponent,
        ErrorMessageComponent,
        DateFieldComponent,
        SelectFieldComponent,
        PhoneFieldComponent,
        EmailFieldComponent,
        RadioFieldComponent,
        CheckboxComponent,
        CustomSelectFieldComponent,
        PasswordFieldComponent,
        SearchInputComponent,
        QuizNPSComponent,
        QuizMobileComponent,
        AutocompleteFioComponent,
        AutocompleteAddressComponent,
        GenderBoxComponent,
        NumberFieldComponent,
        OtpFieldComponent,
        DateInputComponent,
        AmountSliderComponent,
        AmountSliderFieldComponent,
        AutocompleteEmailComponent
    ],
  providers: [
    Dadata2Service,
    CustomValidators,
    provideEnvironmentNgxMask(maskConfig),
  ],
  exports: [
    RegistrationProgressBarComponent,
    SmsCodeFieldComponent,
    TextFieldComponent,
    MultilineTextFieldComponent,
    ErrorMessageComponent,
    DateFieldComponent,
    SelectFieldComponent,
    PhoneFieldComponent,
    EmailFieldComponent,
    RadioFieldComponent,
    CheckboxComponent,
    CustomSelectFieldComponent,
    PasswordFieldComponent,
    SearchInputComponent,
    QuizNPSComponent,
    QuizMobileComponent,
    AutocompleteFioComponent,
    AutocompleteAddressComponent,
    GenderBoxComponent,
    NumberFieldComponent,
    DateInputComponent,
    AmountSliderFieldComponent,
    AmountSliderComponent,
    AutocompleteEmailComponent
  ],
})
export class FormModule {}
